// extracted by mini-css-extract-plugin
export var copyableField = "_k7-4";
export var customerBadge = "_k7-0";
export var customerInfoTitle = "_k7-2";
export var details = "_k7-1";
export var dropdownContainer = "_k7-5";
export var dropdownImage = "_k7-6";
export var editAssigneeForm = "_k7-a";
export var editButton = "_k7-3";
export var email = "_k7-7";
export var hidden = "_k7-d";
export var input = "_k7-8";
export var saveButton = "_k7-b";
export var shopifyIcon = "_k7-c";
export var suggestionBadge = "_k7-e";
export var suggestionText = "_k7-f";
export var username = "_k7-9";